// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-041df88c]{background:linear-gradient(#61c7f7,#009ce5)}.circle[data-v-041df88c]{height:36px;width:36px;line-height:36px;background:#fff;border-radius:50%}.modal[data-v-041df88c]{transform:translateZ(1px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
